import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {LastPage,AllInclusive,Add,MoreVert,Edit,Delete,Done,Block} from '@material-ui/icons';

import { withLocalize,Translate } from "react-localize-redux";

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  CircularProgress,
  FormHelperText
} from "@material-ui/core";

import MUIDataTable from "mui-datatables";

import { useSnackbar } from 'notistack';

import {TransportService} from "./../../utils/web_config_2";

import UserInfo from "./login_info";

import axios from 'axios';

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
}
}));


 function Offenses() {
  const classes = useStyles1();

  
  // new offense dialog 

  const [open, setOpen] = useState(false);

  const [operatorData, setOperatorData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [offenseMessage,setOffenseMessage]=useState("Loading...");

  const [categoryMessage,setCategoryMessage]=useState("Loading...");


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

//offenses table 


const columns = [
  {
    name: "id",
    label: "id",
    options: {
     display:false,
     filter: true,
     sort: true,
    }
   },
  {
   name: "name",
   label: <Translate id="operator_offense_fines.table.name" />,
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "code",
   label: <Translate id="operator_offense_fines.table.code" />,
   options: {
    filter: true,
    sort: false,
   }
  },
  {
   name: "amount",
   label: <Translate id="operator_offense_fines.table.amount" />,
   options: {
    filter: true,
    sort: false,
   }
  }, {
    name: "description",
    label: <Translate id="operator_offense_fines.table.description" />,
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "status",
    label: <Translate id="operator_offense_fines.table.status" />,
    options: {
     filter: true,
     sort: false,
     customBodyRender: (value, tableMeta, updateValue) => {
       if(value=="ACTIVE"){
        return (
          <Chip
          color="primary"
          label={value}
          variant="outlined"
          onDelete={()=>{}}
          deleteIcon={<Done />}
        ></Chip>
            
        );
       }else{
        return (
          <Chip
          color="secondary"
          label={value}
          onDelete={()=>{}}
          deleteIcon={<Block />}
        ></Chip>
            
        );
       }
      
    }
    }
   }
 ];

 
 const options = {textLabels: {
  body: {
    noMatch: categoryMessage
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:"single",
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    <Box>

  <IconButton onClick={()=>{
     var id=displayData[selectedRows.data[0]['index']]['data'][0];
     var obj=offenses.find((o)=>o.id==id);
     setId(id);
     setName({value:obj.name,error:""});
     setCode({value:obj.code,error:""});
     setCategory({value:obj.category.id,error:""});
     setDescription({value:obj.description,error:""});
     setAmount({value:obj.amount,error:""});
     setEditDialog(true);
  }} aria-label="Edit">
  <Edit/>
  </IconButton>

      </Box>
  ),
 };


 useEffect(()=>{

  var data = {};
  const data1 = localStorage.getItem("nx_op");
  if (data1 != null) {
    data = JSON.parse(data1);
  }

  setOperatorData(data);
  axios.defaults.baseURL = new TransportService().BASE_URL;

  get_offense(data.token);
  get_categories(data.token);



 },[]);


 /// get offense

 const [offenseLoad,setOffenseLoad]=useState(false);
 const [offenses,setOffenses]=useState([]);
 const get_offense=(token)=>{
  setOffenseLoad(true);
  setOffenseMessage("Loading...");
  const offenseInstance = axios.create(new TransportService().setHeaders(token));
  offenseInstance.get("/api/v1/fines/getOffenses")
  .then(res=>{
    console.log(res);
    if(res.data.data.length==0){
      console.log("categories");
      setOffenseMessage("No offenses available");
    }
    setOffenses(res.data.data);
    setOffenseLoad(false);

  }).catch(err=>{
    setOffenseLoad(false);
    setOffenseMessage("Something went wrong");
    if(err.message){
      enqueueSnackbar(err.message,
        { 
          variant: 'error'
      });
    }

    if(err.response){
      enqueueSnackbar(err.response.data.message,
        { 
          variant: 'error'
      });
    }
   

  });
 }
 

 // get offense categories
 const [categories,setCategories]=useState([]);
 const get_categories=(token)=>{
  const categoryInstance = axios.create(new TransportService().setHeaders(token));
  categoryInstance.get('/api/v1/fines/getOffenseCategories')
  .then(res=>{
    
    var d=res.data.data;
    console.log(res);
    if(d.length==0){
      setCategoryMessage("No categories available");
    }
    setCategories(res.data.data);
  }).catch(err=>{
    enqueueSnackbar(err.message,
      { 
        variant: 'error'
    });
  });
 }

 // add offense

 const [addLoad,setAddLoad]=useState(false);

 const [name,setName]=useState({value:"",error:""});
 const [code,setCode]=useState({value:"",error:""});
 const [category,setCategory]=useState({value:0,error:""});
 const [description,setDescription]=useState({value:"",error:""});
 const [amount,setAmount]=useState({value:0,error:""});
 const [type,setType]=useState({value:"",error:""});

 const add_offense=()=>{
   if(name.value===""){
     setName({value:"",error:"Enter name"});
   }else if(code.value===""){
     setCode({value:"",error:"Enter code"});
   }else if(category.value===0){
     setCategory({value:0,error:"Select category"});
   }else if(description.value===""){
     setDescription({value:"",error:"Enter description"});
   }else if(amount.value==0){
     setAmount({value:0,error:"Enter amount"});
   }else if(type.value==""){
     setType({value:"",error:"Please select type"});
   }else{
    setAddLoad(true);
    const addInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    addInstance.post('/api/v1/fines/addOffense',
    {
      "amount": amount.value,
      "category_id": category.value,
      "code": code.value,
      "description": description.value,
      "name": name.value,
      "type":type.value
    })
    .then(res=>{

      var obj=res.data.data;
      var o=offenses;
      o.unshift(obj);
      setOffenses(o);

    setOpen(false);
      setAddLoad(false);

      enqueueSnackbar("Offense added successful!",
        { 
          variant: 'success'
      });
    }).catch(err=>{
      setAddLoad(false);
      if(err.message){

        if(err.response.status==400){
          enqueueSnackbar("Invalid offense,Already exist!",
            { 
              variant: 'error'
          });
        }
        
      }
    });

   }
 }


//  edit offense dialog 
const [editDialog,setEditDialog]=useState(false);

// edit offense

const [id,setId]=useState(0);
const [editLoad,setEditLoad]=useState(false);
const edit_offense=()=>{
  if(name.value===""){
    setName({value:"",error:"Enter name"});
  }else if(code.value===""){
    setCode({value:"",error:"Enter code"});
  }else if(category.value===0){
    setCategory({value:0,error:"Select category"});
  }else if(description.value===""){
    setDescription({value:"",error:"Enter description"});
  }else if(amount.value==0){
    setAmount({value:0,error:"Enter amount"});
  }
  else{
    setEditLoad(true);
    const editInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    editInstance.put('/api/v1/fines/modifyOffense',
    {
      "amount": amount.value,
      "category_id": category.value,
      "code": code.value,
      "description": description.value,
      "id": id,
      "name": name.value,
      "type":type.value
    }).then(res=>{
      var obj=res.data.data;
      var index=offenses.findIndex((o)=>o.id==id);
      var objs=offenses;
      objs[index]=obj;
      setOffenses(objs);
      setEditLoad(false);
      setEditDialog(false);
      enqueueSnackbar("Offense updated successful!",
      { 
        variant: 'success'
    });
    }).catch(err=>{
      setEditLoad(false);
      if(err.message){

        if(err.response.status==400){
          enqueueSnackbar("Invalid offense,Already exist!",
            { 
              variant: 'error'
          });
        }
        
      }
    });

  }

}


  return (
    <div className={classes.root}>
      <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}><AllInclusive fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b><Translate id="operator_offense_fines.offense_fine"/></b></Typography>

 </Box>
 
 
<Button  
className={classes.btn}
size="small"
startIcon={<Add/>} 
onClick={()=>{handleClickOpen()}} 
variant="contained" 
color="primary"
disableElevation={true}>

<Typography noWrap><Translate id="operator_offense_fines.new_offense"/></Typography>
</Button>

</Box>


<Box mt={2}>
  {offenseLoad&&<LinearProgress/>}
<MUIDataTable
  title={"Offense list"}
  data={offenses}
  columns={columns}
  options={options}
/>
</Box> 


{/* dialog new offense  */}

    <Dialog
    maxWidth="sm"
    fullWidth
        open={open}
        onClose={()=>{
          setOpen(false);
        }}
        aria-labelledby="new branch"
        aria-describedby="new bramnch"
      >
        <DialogTitle id="new branch">{"New Offense"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
             
          <Box display='flex' alignItems='center' justifyContent='center'>
            <TextField 
            onChange={(e)=>{
              if(e.target.value===""){
                setCode({value:"",error:"Enter code"});
              }else{
                setCode({value:e.target.value,error:""});
              }
            }}

            error={code.error!=""}
            helperText={code.error}

            size='small' variant='outlined' label={<Translate id="operator_offense_fines.form_new_offense.code"/>}  color='primary'  fullWidth    /></Box>
              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                <TextField 
                onChange={(e)=>{
                  if(e.target.value===""){
                    setName({value:"",error:"Enter name"});
                  }else{
                    setName({value:e.target.value,error:""});
                  }
                }}
    
                error={name.error!=""}
                helperText={name.error}
                
                size='small' variant='outlined' label={<Translate id="operator_offense_fines.form_new_offense.offense"/>} color='primary'  fullWidth    /></Box>
              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                <TextField
                 onChange={(e)=>{
                  if(e.target.value==0){
                    setAmount({value:"",error:"Enter amount "});
                  }else{
                    setAmount({value:e.target.value,error:""});
                  }
                }}
    
                error={amount.error!=""}
                helperText={amount.error}
                 
                size='small' type="number" variant='outlined' label={<Translate id="operator_offense_fines.form_new_offense.amount"/>}  color='primary'  fullWidth    /></Box>
             
              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
      
                 <InputLabel htmlFor="category"><Translate id="operator_offense_fines.form_new_offense.choose_category"/></InputLabel>
        <Select
        size="small"
        label="Select category"
        inputProps={{
          name: 'category',
          id: 'category',
        }}

        onChange={(e)=>{
          if(e.target.value==0){
            setCategory({value:0,error:"Select category"});
          }else{
            setCategory({value:e.target.value,error:""});
          }
        }}

        >
          <MenuItem value={0}>
            <em>None</em>
          </MenuItem>
          {categories.map((c)=>{
            return <MenuItem value={c['id']}>{c['name']}</MenuItem>;
          })}
         
        </Select>
        <FormHelperText error={category.error!=""}>{category.error}</FormHelperText>
      </FormControl>
</Box>

<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
      
                 <InputLabel htmlFor="category">Offense Type</InputLabel>
        <Select
        size="small"
        label="Select type"
        inputProps={{
          name: 'type',
          id: 'type',
        }}

        onChange={(e)=>{
          if(e.target.value==0){
            setType({value:0,error:"Select offense type"});
          }else{
            setType({value:e.target.value,error:""});
          }
        }}
        >
          <MenuItem value={0}>
            <em>None</em>
          </MenuItem>
          <MenuItem value={"DRIVER"}>Driver</MenuItem>
          <MenuItem value={"OPERATOR"}>Operator</MenuItem>
          <MenuItem value={"VEHICLE"}>Vehicle</MenuItem>
          <MenuItem value={"TRAVELER"}>Traveler</MenuItem>
         
        </Select>
        <FormHelperText error={type.error!=""}>{type.error}</FormHelperText>
      </FormControl>
</Box>

<Box mt={1}>
    <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  
<TextField
fullWidth
multiline
variant='outlined'
      rows={10}
      aria-label={<Translate id="operator_offense_fines.form_new_offense.description" />}
      placeholder="Description"
      onChange={(e)=>{
        if(e.target.value==""){
          setDescription({value:"",error:"Enter description"});
        }else{
          setDescription({value:e.target.value,error:""});
        }
      }}
      error={description.error!=""}
      helperText={description.error}
    />
     </FormControl>
</Box>
                      
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
         
          <Button onClick={()=>{
            setOpen(false);
          }} color="secondary" className={classes.btn}>
            <Typography><Translate id="operator_offense_fines.form_new_offense.cancel" /></Typography>
          </Button>


          <Button disableElevation onClick={()=>{
            add_offense();
          }} variant="contained" color="primary" className={classes.btn}>

            {addLoad?<CircularProgress size={25} color="secondary" />:<Typography><Translate id="operator_offense_fines.form_new_offense.save" /></Typography>}

          </Button>
        </DialogActions>
      </Dialog>



{/* dialog edit offense  */}

<Dialog
    maxWidth="sm"
    fullWidth
        open={editDialog}
        onClose={()=>{
          setEditDialog(false);
        }}
        aria-labelledby="edit_offense"
        aria-describedby="edit_offense"
      >
        <DialogTitle id="edit_offense">{"Edit Offense"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
             
          <Box display='flex' alignItems='center' justifyContent='center'>
            <TextField 
            value={code.value}
            onChange={(e)=>{
              if(e.target.value===""){
                setCode({value:"",error:"Enter code"});
              }else{
                setCode({value:e.target.value,error:""});
              }
            }}

            error={code.error!=""}
            helperText={code.error}

            size='small' variant='outlined' label={<Translate id="operator_offense_fines.form_new_offense.code"/>}  color='primary'  fullWidth    /></Box>
              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                <TextField
                value={name.value} 
                onChange={(e)=>{
                  if(e.target.value===""){
                    setName({value:"",error:"Enter name"});
                  }else{
                    setName({value:e.target.value,error:""});
                  }
                }}
    
                error={name.error!=""}
                helperText={name.error}
                
                size='small' variant='outlined' label={<Translate id="operator_offense_fines.form_new_offense.offense"/>} color='primary'  fullWidth    /></Box>
              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                <TextField
                value={amount.value}
                 onChange={(e)=>{
                  if(e.target.value==0){
                    setAmount({value:"",error:"Enter amount "});
                  }else{
                    setAmount({value:e.target.value,error:""});
                  }
                }}
    
                error={amount.error!=""}
                helperText={amount.error}
                 
                size='small' type="number" variant='outlined' label={<Translate id="operator_offense_fines.form_new_offense.amount"/>}  color='primary'  fullWidth    /></Box>
             
              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
      
                 <InputLabel htmlFor="category"><Translate id="operator_offense_fines.form_new_offense.choose_category"/></InputLabel>
        <Select
        size="small"
        label="Select category"
        inputProps={{
          name: 'category',
          id: 'category',
        }}

        onChange={(e)=>{
          if(e.target.value==0){
            setCategory({value:0,error:"Select category"});
          }else{
            setCategory({value:e.target.value,error:""});
          }
        }}

        >
          <MenuItem value={0}>
            <em>None</em>
          </MenuItem>
          {categories.map((c)=>{
            return <MenuItem value={c['id']}>{c['name']}</MenuItem>;
          })}
         
        </Select>
        <FormHelperText error={category.error!=""}>{category.error}</FormHelperText>
      </FormControl>
</Box>

<Box mt={1}>
    <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  
<TextField
value={description.value}
fullWidth
multiline
variant='outlined'
      rows={10}
      aria-label={<Translate id="operator_offense_fines.form_new_offense.description" />}
      placeholder="Description"
      onChange={(e)=>{
        if(e.target.value==""){
          setDescription({value:"",error:"Enter description"});
        }else{
          setDescription({value:e.target.value,error:""});
        }
      }}
      error={description.error!=""}
      helperText={description.error}
    />
     </FormControl>
</Box>
                      
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
         
          <Button onClick={()=>{
            setEditDialog(false);
          }} color="secondary" className={classes.btn}>
            <Typography><Translate id="operator_offense_fines.form_new_offense.cancel" /></Typography>
          </Button>


          <Button disableElevation onClick={()=>{
        edit_offense();
          }} variant="contained" color="primary" className={classes.btn}>

            {editLoad?<CircularProgress size={25} color="secondary" />:<Typography><Translate id="operator_offense_fines.form_new_offense.save" /></Typography>}

          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default withLocalize(Offenses)